/**
 * AIScore badge: 0-100 buying intent visualization.
 * Color: red < 40, yellow 40-69, green >= 70
 */
import { Brain } from "@phosphor-icons/react";

export function scoreColor(score) {
  if (score == null) return { bg: "transparent", text: "#71717A", border: "#27272A" };
  if (score >= 70) return { bg: "rgba(16,185,129,0.12)", text: "#10B981", border: "rgba(16,185,129,0.4)" };
  if (score >= 40) return { bg: "rgba(245,158,11,0.12)", text: "#F59E0B", border: "rgba(245,158,11,0.4)" };
  return { bg: "rgba(239,68,68,0.12)", text: "#EF4444", border: "rgba(239,68,68,0.4)" };
}

export default function AIScore({ score, size = "sm", showLabel = false }) {
  const c = scoreColor(score);
  if (score == null) {
    return showLabel ? (
      <span className="text-[10px] text-[#71717A] uppercase tracking-wider">Sin analisis</span>
    ) : null;
  }
  if (size === "lg") {
    return (
      <div
        className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md border font-mono-jb"
        style={{ background: c.bg, borderColor: c.border, color: c.text }}
        data-testid={`ai-score-${score}`}
      >
        <Brain size={14} weight="fill" />
        <span className="text-base font-medium">{score}</span>
        <span className="text-[10px] opacity-70">/100</span>
      </div>
    );
  }
  return (
    <span
      className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-mono-jb font-medium"
      style={{ background: c.bg, color: c.text }}
      data-testid={`ai-score-${score}`}
    >
      <Brain size={9} weight="fill" />
      {score}
    </span>
  );
}
